// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3aGbk","info":"PatientInfo_info__aj7Ay"};